import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import CloseCircleFillNegativeIcon from '@icons/CloseCircleFillNegativeIcon';
import { PresignedUrlResponse } from '@models/file';
import {
  Dispatch, SetStateAction, useRef, useState,
} from 'react';

import useUploadFile from './hooks/useUploadFile';
import styles from './styles.module.scss';
import UploadImageIcon from './UploadImageIcon';

interface Props {
    maxLength?: number;
    maxFileSize?: number;
    caption?: string;
    placeholder?: string;
    value?: string[];
    setValue?: Dispatch<SetStateAction<string[]>>
}

function ImageUploader({
  maxLength, maxFileSize, caption, placeholder, value, setValue,
}:Props) {
  const ref = useRef<HTMLInputElement>(null);
  const handleClick = () => {
    ref.current?.click();
  };
  const [preview, setPreview] = useState<PresignedUrlResponse[]>([]);
  const { onFileChange, removeFile } = useUploadFile({
    preview, setPreview, value, setValue, maxLength,
  });
  return (
        <Column fullWidth spacing={12}
                onClick={handleClick}>
            <Row className={styles.container} fullWidth>
                {placeholder && <Text color={colors.gray5}>
                    {placeholder}
                </Text>}
                <UploadImageIcon className={styles.icon}/>
            </Row>
            {caption && (
                <Text color={colors.gray5} size='s'>
                    {caption}
                </Text>
            )}
            <input type='file' ref={ref} hidden
                   onChange={onFileChange}
                   accept='image/*' />

            {preview.length !== 0 && (
                <PreviewContainer>
                    {preview.map((p) => (
                        <Preview key={p.tempFileKey}>
                            <StyledImage src={p.tempImageUrl}
                                   width={78}
                                   height={78} />
                            <RemoveIcon size={32}
                                        color={colors.gray4}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          removeFile(p.tempFileKey);
                                        }}
                            />
                        </Preview>
                    ))}
                </PreviewContainer>
            )}
        </Column>
  );
}

const PreviewContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;
`;

const StyledImage = styled(Image)`
    width: 80px;
    height: 80px;
    border: 1px solid ${colors.gray3};
    border-radius: 8px;
`;

const Preview = styled.div`
    position: relative;
`;

const RemoveIcon = styled(CloseCircleFillNegativeIcon)`
    position: absolute;
    top: -12px;
    right: -12px;
    cursor: pointer;
`;

export default ImageUploader;
